import { render } from "./LucideIcon.vue?vue&type=template&id=f711c9be&scoped=true"
import script from "./LucideIcon.vue?vue&type=script&lang=js"
export * from "./LucideIcon.vue?vue&type=script&lang=js"

import "./LucideIcon.vue?vue&type=style&index=0&id=f711c9be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f711c9be"]])

export default __exports__